import type { SubscriptionOrder } from '@entities/subscription'

import { getOrderUrl } from '@shared/lib/routes'
import { formatPrice } from '@shared/lib/format'

import { formatSubscriptionDateTime } from './subscription-options'
import { SUBSCRIPTION_EMPTY_CELL } from './subscription-rules'

interface SubscriptionPaymentsReturn {
  getOrderUrl: (orderId: number) => string
  getNumber: (order: SubscriptionOrder) => string
  getTotal: (order: SubscriptionOrder) => string
  getPaidAt: (order: SubscriptionOrder) => string
}

export const useSubscriptionPayments = (): SubscriptionPaymentsReturn => ({
  getOrderUrl,
  getNumber: order => (order.number !== null ? String(order.number) : SUBSCRIPTION_EMPTY_CELL),
  getTotal: order => formatPrice(order.total),
  getPaidAt: order => formatSubscriptionDateTime(order.succeeded_at),
})
